import React from "react";
interface props {
  className?: string;
}

function Icon4({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 42"
    >
      <circle cx="21" cy="20.996" r="20.5" stroke="#FF752C"></circle>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21a4 4 0 100-8 4 4 0 000 8z"
      ></path>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 29.001v-1a7 7 0 0110-6.326m1.635 3.741l1.039-2.203a.357.357 0 01.652 0l1.04 2.203 2.323.356c.298.045.416.43.2.65l-1.68 1.712.396 2.421c.051.311-.26.548-.527.401L27 29.813l-2.078 1.143c-.267.147-.578-.09-.527-.4l.396-2.422-1.68-1.713c-.216-.22-.098-.604.2-.65l2.324-.355z"
      ></path>
    </svg>
  );
}

export default Icon4;
